export default __webpack_public_path__ + "static/media/writeoff.cfff50e5.svg";